export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "new_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Feature Role"])},
        "delete_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete Feature Role"])},
        "delete_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to delete this feature role?"])}
      },
      "fr": {
        "new_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau rôle de fonctionnalité"])},
        "delete_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le rôle de fonction"])},
        "delete_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voulez-vous vraiment supprimer ce rôle de fonctionnalité?"])}
      }
    }
  })
}